import React from 'react';
import styled from 'styled-components';

const EmojiDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.5rem;
  z-index: 1000;
  width: 300px;
`;

const EmojiButton = styled.button`
  border: none;
  background: transparent;
  font-size: 1.25rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
  }
`;

const commonEmojis = [
  '😊',
  '😂',
  '🥰',
  '😎',
  '🤔',
  '👍',
  '❤️',
  '✨',
  '🎉',
  '🔥',
  '👏',
  '🙌',
  '💪',
  '🤝',
  '👋',
  '🌟',
  '💡',
  '📌',
  '✅',
  '⭐',
  '💯',
  '🎯',
  '🚀',
  '💌',
];
const EmojiPicker = ({ onEmojiSelect }) => {
  return (
    <EmojiDropdown>
      {commonEmojis.map((emoji, index) => (
        <EmojiButton key={index} onClick={() => onEmojiSelect(emoji)} title={`Insert ${emoji}`}>
          {emoji}
        </EmojiButton>
      ))}
    </EmojiDropdown>
  );
};

export default EmojiPicker;
